export enum PortfolioHistoryEngineVersionEnum {
	V2 = 'v2',
}
